// extracted by mini-css-extract-plugin
export default {"Flash":"HiddenUnicode-module__Flash--NH4EI","Button":"HiddenUnicode-module__Button--wjP7v","Octicon":"HiddenUnicode-module__Octicon--GY9_l"};